import e from "../../bundled_deps/.pnpm/camelcase@8.0.0/bundled_deps/camelcase/index.js";
//#region src/specs/decorators/uploadable.ts
var t = "embercom-prosemirror-retry-upload", n = "file-guid";
function r(e) {
	e.attrs = Object.assign({}, e.attrs, {
		fileGUID: { default: "" },
		uploadFailed: { default: !1 },
		failureReason: { default: "" },
		retryable: { default: !0 }
	});
	let r = e.toDOM;
	return e.toDOM = (e) => {
		let i = e.attrs, a = r(e);
		if (Array.isArray(a) && a.length > 1 && (a[1][n] = i?.fileGUID), i?.uploadFailed === !0) {
			let r = [];
			if (i.retryable) {
				let e = { class: t };
				e[`data-${n}`] = i?.fileGUID, r = [
					"a",
					e,
					"try again"
				];
			}
			return [
				"div",
				{ class: "embercom-prosemirror-upload-failed" },
				[
					"div",
					{ class: "embercom-prosemirror-upload-failed-inner" },
					[
						"div",
						{ class: "embercom-prosemirror-upload-info" },
						o(),
						e.attrs.failureReason
					],
					r
				],
				a
			];
		}
		return a;
	}, e;
}
function i(t, r) {
	r.target?.classList.contains("embercom-prosemirror-retry-upload") && t?.commands.retryUpload(r.target.dataset[e(n)]);
}
function a(e) {
	return e.type === "success" ? {
		fileGUID: "",
		uploadFailed: !1,
		failureReason: ""
	} : {
		uploadFailed: !0,
		failureReason: e.reason,
		retryable: e.retryable
	};
}
function o() {
	let e = document.createElementNS("http://www.w3.org/2000/svg", "svg");
	e.setAttributeNS(null, "fill", "red"), e.setAttribute("class", "interface-icon o__standard o__by-text"), e.setAttributeNS(null, "viewBox", "0 0 16 16");
	let t = document.createElementNS("http://www.w3.org/2000/svg", "path");
	return t.setAttributeNS(null, "fill-rule", "oddeven"), t.setAttributeNS(null, "d", "M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14zm0-6.083a.701.701 0 0 1-.697-.621L6.88 4.615A1 1 0 0 1 7.872 3.5h.256a1 1 0 0 1 .993 1.115l-.424 3.68A.701.701 0 0 1 8 8.918zM8 12.5c-.714 0-1.25-.536-1.25-1.25S7.286 10 8 10s1.25.536 1.25 1.25S8.714 12.5 8 12.5z"), e.appendChild(t), e;
}
//#endregion
export { n as UPLOAD_FILE_GUID, t as UPLOAD_RETRY_CLASS, i as handleUploadRetry, a as uploadResultToNodeAttrs, r as uploadable };
